import script from "./DvwUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./DvwUploader.vue?vue&type=script&setup=true&lang=js"

import "./DvwUploader.vue?vue&type=style&index=0&id=4f1bd044&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1bd044"]])

export default __exports__